/**
 * Component which represents a "reserved" spot on the map, which cannot share the same spot with
 * another obstacle. Doors, fridges, level objects you can't pass through.
 */
export function Obstacle(base) {
    return class extends base {
        constructor(...args) {
            super(...args);
            this.shelfHeight = 0;
            this.reservedTile = this.levelMap.worldToTile(this.position);
            if (!this.levelMap.reserveSpace(this.reservedTile, this)) {
                throw new Error(`Failed to place ${this.constructor.name} obstacle at [ ${this.reservedTile.x}, ${this.reservedTile.y} ]`);
            }
        }
        getProperties() {
            return Object.assign(Object.assign({}, super.getProperties()), { obstacle: true });
        }
        get tilePos() {
            return this.reservedTile;
        }
        moveToTile(tile) {
            if (!this.levelMap.reserveSpace(tile, this)) {
                return false;
            }
            if (this.reservedTile) {
                this.levelMap.releaseSpace(this.reservedTile, this);
            }
            this.reservedTile = tile;
            return true;
        }
    };
}
export function isObstacle(obj) {
    return 'tilePos' in obj;
}
